<div
  class="table"
  [class.table--fade-right]="overflows?.right"
  [class.table--fade-left]="overflows?.left"
  prlwResponsive
>
  <div *ngIf="overflows?.top" class="top-fade"></div>

  <div class="basis-column">
    <div class="table-header">
      <prlw-all-table-column-header
        [column]="BASIS"
        (click)="sort(BASIS.name)"
        data-cy="all-table-column-header"
      ></prlw-all-table-column-header>
    </div>
    <div class="table-content">
      <div class="scroll" (scroll)="setVerticalScroll($event)" prlwSyncScroll>
        <div
          *ngFor="let instrument of data; let i = index"
          class="table-row"
          data-cy="table-row"
        >
          <prlw-all-table-column-content
            [column]="BASIS"
            [instrument]="instrument"
          ></prlw-all-table-column-content>
        </div>
      </div>
    </div>
  </div>
  <div
    class="header-row"
    [class.header-row--right-plug]="overflows?.right"
    [class.header-row--left-plug]="overflows?.left"
  >
    <div
      *ngIf="overflows?.right"
      class="header-row-fade header-row-fade--right"
    ></div>
    <div
      *ngIf="overflows?.left"
      class="header-row-fade header-row-fade--left"
    ></div>
  </div>
  <div
    #tableContentWrapper
    class="table-content-wrapper"
    (scroll)="setHorizontalScroll($event)"
  >
    <div
      class="table-header"
      [style.grid-template-columns]="gridSize"
      cdkDropList
      cdkDropListOrientation="horizontal"
      cdkDropListLockAxis="x"
      (cdkDropListDropped)="drop($event)"
    >
      <prlw-all-table-column-header
        *ngFor="let column of columns"
        cdkDrag
        cdkDragLockAxis="x"
        [column]="column"
        (click)="sort(column.name)"
        data-cy="all-table-column-header"
      ></prlw-all-table-column-header>
    </div>
    <div class="table-content">
      <div
        #scroll
        class="scroll"
        (scroll)="setVerticalScroll($event)"
        prlwSyncScroll
      >
        <div
          *ngFor="let instrument of data; let i = index"
          class="table-row"
          data-cy="table-row"
          [style.grid-template-columns]="gridSize"
        >
          <prlw-all-table-column-content
            *ngFor="let column of columns"
            [column]="column"
            [instrument]="instrument"
            [modifiers]="modifiers"
            [destination]="destination"
          ></prlw-all-table-column-content>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="overflows?.bottom" class="bottom-fade"></div>
</div>
